import Button from "../Button/Button";
import { useTranslation } from "react-i18next";
import { OrderV2 } from "@/shared/v2/queries/interfacesV2";
import useOrderHelper from "@/shared/v2/hooks/useOrderHelper";
import usePrintReceipt from "@/shared/hooks/usePrintReceipt";

const OrderCardPrintButton = ({ order }: { order: OrderV2 }) => {
  const { t } = useTranslation();
  const { item_id, branch_id } = useOrderHelper(order);
  const printReceipt = usePrintReceipt();

  const handlePrint = () => {
    printReceipt(item_id, branch_id);
  };

  return (
    <Button
      size="small"
      variant="secondary"
      onClick={(e) => {
        e.stopPropagation();
        handlePrint();
      }}
      className={"p-2! 2xl:px-btn-small-x 2xl:py-btn-small-y"}
    >
      <span className="text-default text-xl 2xl:text-2xl">{t("print")}</span>
    </Button>
  );
};

export default OrderCardPrintButton;
